import { formatDate as toolboxFormatDate, FormatDateOptions, Nullish } from '@omnea-digital/toolbox'
import { useMemo } from 'react'
import { parseDateString } from 'utils/date/parseDateString'
import { getDateFnsLocaleObject } from './getDateFnsLocaleObject'
import { useTranslationsContext } from './TranslationsContext'

export type DateFormatterOptions = Omit<FormatDateOptions, 'locale'>

export type FrontendFormatter = ReturnType<typeof useFormatter>

export const useFormatter = () => {
  const { locale } = useTranslationsContext()

  return useMemo(() => {
    const formatDate = (date: Date, options: DateFormatterOptions): string => toolboxFormatDate(date, { ...options, locale })

    const formatDateString = (dateString: Nullish<string>, options: DateFormatterOptions): string | null => {
      const date = parseDateString(dateString)
      if (!date) return null
      return formatDate(date, options)
    }

    const formatAmount = (number: number, minimumFractionDigits = 2, maximumFractionDigits = 2) =>
      new Intl.NumberFormat(locale, { minimumFractionDigits, maximumFractionDigits }).format(number)

    const formatPercentage = (number: number) => formatAmount(number, 0, 1)

    return {
      formatDate,
      formatDateString,
      formatAmount,
      formatPercentage,
      locale,
      dateFnsLocale: getDateFnsLocaleObject(locale),
    }
  }, [locale])
}
